module.exports = __webpack_public_path__ + "97f08789e5f055c03e7788a9a5f2ec43.png";